/* ============
 * Product Bundle Transformer
 * ============
 *
 * The transformer for the product bundle.
 */

import Transformer from './transformer';

export default class ProductBundleTransformer extends Transformer {

  static fetch(productBundle) {
    return {
      name: productBundle.name,
      price: productBundle.price,
      description: productBundle.description,
      products: productBundle.products,
      productBundleGroup: productBundle.product_bundle_group,
    };
  }

  static send(productBundle) {
    return {
      name: productBundle.name,
      price: productBundle.price,
      description: productBundle.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productBundle.js